// extracted by mini-css-extract-plugin
module.exports = {"top":"Top_top__3eCC8","icon":"Top_icon__1IIHY","right":"Top_right__lUiIm"};